/* istanbul ignore file */
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { merge } from 'lodash';

export const useQueryParams = (options = {}) => {
  const { search } = useLocation();
  return queryString.parse(search, merge({ parseBooleans: true }, options));
};
